<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19.015 9.98499V6.97H16V5H19.015V1.98499H20.985V5H24V6.97H20.985V9.98499H19.015ZM21 17.3242V11.917C20.6748 11.9716 20.3407 12 20 12C19.6593 12 19.3252 11.9716 19 11.917V17.3242H5V8.22375L9.87885 13.1026C11.0504 14.2742 12.9499 14.2742 14.1215 13.1026L16.4135 10.8106C15.8762 10.4093 15.4083 9.92015 15.0313 9.36438L12.7073 11.6884C12.3168 12.0789 11.6836 12.0789 11.2931 11.6884L6.57232 6.96765H14.0776C14.0265 6.65265 14 6.32943 14 6C14 5.65929 14.0284 5.32521 14.083 5H4.00977C3.45748 5 3.00977 5.44772 3.00977 6V6.18391C3.00333 6.22976 3 6.2766 3 6.32422V17.3242C3 18.4288 3.89543 19.3242 5 19.3242H19C20.1046 19.3242 21 18.4288 21 17.3242Z"
  />
</template>
